const EVENTS = {
    userData: "dh-user-data",
    sessionExpired: "dh-session-expired",
}
export default EVENTS;